<template>
  <transition name="fade">
    <div
      class="gift_card_dialog__modal-mask"
      v-if="isActive"
      v-on:click.self="closeGiftCardDialog"
    >
      <div class="gift_card_dialog__modal_content_container">
        <div class="gift_card_dialog__modal_content_wrapper">
          <nav class="gift_card_dialog__navigation">
            <p class="gift_card_dialog__title">{{ dialogSetTitle }}</p>
          </nav>
          <transition name="slide-fade" mode="in-out">
            <section
              class="gift_card__dialog_set"
              v-if="dialogSetIndex === GIFT_CARD_DIALOG_INDEX.ISSUE_CONFIRM"
            >
              <div v-if="dialogBrand === GIFT_CARD_BRAND.GOOGLE">
                <p class="gift_card_dialog__google_message">
                  {{ dialogSetMessage }}
                </p>
              </div>
              <div v-if="dialogBrand !== GIFT_CARD_BRAND.GOOGLE">
                <p class="gift_card_dialog__message">{{ dialogSetMessage }}</p>
              </div>
              <ButtonSubmit
                id="gift_card__cancel_button"
                title="キャンセル"
                v-bind:disabled="!canSubmitDialog"
                v-on:click.native="closeGiftCardDialog"
              />
              <ButtonSubmit
                id="gift_card__ok_button"
                title="OK"
                v-bind:disabled="!canSubmitDialog"
                v-on:click.native="submit"
              />
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              class="gift_card__dialog_set"
              v-if="dialogSetIndex === GIFT_CARD_DIALOG_INDEX.ISSUE_API_OK"
            >
              <p class="gift_card_dialog__message">
                交換したギフトコードを
                <br />
                チャットでお送りしました
              </p>
              <ButtonSubmit
                id="gift_card_send__ok_button"
                title="OK"
                v-bind:disabled="false"
                v-on:click.native="reload"
              />
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              class="gift_card__dialog_set"
              v-if="dialogSetIndex === GIFT_CARD_DIALOG_INDEX.POINT_ERROR"
            >
              <p class="gift_card_dialog__message">
                LIVEポイントが不足しています
              </p>
              <ButtonSubmit
                id="gift_card_point__ok_button"
                title="OK"
                v-bind:disabled="false"
                v-on:click.native="closeGiftCardDialog"
              />
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              class="gift_card__dialog_set"
              v-if="dialogSetIndex === GIFT_CARD_DIALOG_INDEX.ISSUE_API_ERROR"
            >
              <p class="gift_card_dialog__message">エラーが発生しました</p>
              <ButtonSubmit
                id="gift_card_error__ok_button"
                title="OK"
                v-bind:disabled="false"
                v-on:click.native="closeGiftCardDialog"
              />
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              class="gift_card__dialog_set"
              v-if="dialogSetIndex === GIFT_CARD_DIALOG_INDEX.ISSUE_API_POSTING"
            >
              <p class="gift_card_dialog__message">{{ dialogSetMessage }}</p>
              <ButtonSubmit
                id="gift_card__cancel_button_disable"
                title="キャンセル"
                v-bind:disabled="true"
                v-on:click.native="closeGiftCardDialog"
              />
              <ButtonSubmit
                id="gift_card__ok_button_disable"
                title="OK"
                v-bind:disabled="true"
                v-on:click.native="submit"
              />
            </section>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { MajorBanks, BankNameInitialGroups } from '@/utils/MasterBank'
import {
  GIFT_CARD_BRAND,
  GIFT_CARD_DIALOG_INDEX,
} from '@/store/modules/components/giftCardDialog'
import { mapGetters, mapState, mapActions } from 'vuex'
import ListItem from '@/components/ListItem'
import ListSubheader from '@/components/ListSubheader'
import ButtonSubmit from '@/components/ButtonSubmit'
export default {
  name: 'GiftCardDialog',
  components: {
    ButtonSubmit,
  },
  data: function () {
    return {
      MAJOR_BANKS: MajorBanks,
      BANK_NAME_INITIAL_GROUPS: BankNameInitialGroups,
      GIFT_CARD_DIALOG_INDEX: GIFT_CARD_DIALOG_INDEX,
      GIFT_CARD_BRAND: GIFT_CARD_BRAND,
      listItemStyle: {},
      listSubheaderStyle: {},
    }
  },
  computed: {
    ...mapState({
      isActive: (state) => state.components.giftCardDialog.isActive,
      dialogSetIndex: (state) => state.components.giftCardDialog.dialogSetIndex,
      dialogSetMessage: (state) =>
        state.components.giftCardDialog.dialogSetMessage,
      dialogBrand: (state) => state.components.giftCardDialog.giftCardBrand,
      giftCardId: (state) => state.components.giftCardDialog.giftCardId,
    }),
    ...mapGetters('components/giftCardDialog', [
      'dialogSetTitle',
      'dialogSetMessage',
      'canSubmitDialog',
    ]),
  },
  methods: {
    ...mapActions('components/giftCardDialog', [
      'onClickOkButton',
      'closeGiftCardDialog',
      'postIssueGiftCard',
      'showGiftCardApiErrorDialog',
    ]),
    submit() {
      this.postIssueGiftCard().catch(() => {
        this.showGiftCardApiErrorDialog()
      })
    },
    reload() {
      document.location.reload()
    },
  },
}
</script>

<style scoped>
.gift_card_dialog__modal-mask {
  position: fixed;
  overflow: hidden;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(38, 38, 38, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
}
.gift_card_dialog__modal_content_container {
  position: relative;
  height: 180px;
  width: 300px;
  background: #ffffff;
  overflow: hidden;
  border-radius: 8px;
  z-index: 1;
}

.gift_card_dialog__modal_content_wrapper {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.gift_card_dialog__navigation {
  width: 100%;
  height: 57px;
  padding-top: 2px;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.1);
  /*border-bottom: #e8e8e8 1px solid;*/
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  top: 0;
  z-index: 1;
}

.gift_card_dialog__title {
  font-family: sans-serif;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #262626;
}

.gift_card_dialog__message {
  font-family: sans-serif;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  margin-right: 16px;
  margin-left: 16px;
  color: #262626;
}
.gift_card_dialog__google_message {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  margin-right: 16px;
  margin-left: 16px;
  color: #262626;
}
.gift_card__dialog_set {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

#gift_card__ok_button {
  width: 135px;
  height: 44px;
  background-color: #ffffff;
  color: black;
  position: absolute;
  bottom: 0;
  right: 0;
}

#gift_card__ok_button_disable {
  width: 135px;
  height: 44px;
  background: #ffffff;
  color: #999;
  position: absolute;
  bottom: 0;
  right: 0;
}

#gift_card__cancel_button {
  width: 135px;
  height: 44px;
  background-color: #ffffff;
  color: black;
  position: absolute;
  bottom: 0;
  left: 0;
}
#gift_card__cancel_button_disable {
  width: 135px;
  height: 44px;
  background: #ffffff;
  color: #999;
  position: absolute;
  bottom: 0;
  left: 0;
}

#gift_card_send__ok_button {
  width: 135px;
  height: 44px;
  background-color: #ffffff;
  color: black;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

#gift_card_point__ok_button {
  width: 135px;
  height: 44px;
  background-color: #ffffff;
  color: black;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

#gift_card_error__ok_button {
  width: 135px;
  height: 44px;
  background-color: #ffffff;
  color: black;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>
